import { Container, Row } from "react-bootstrap";
import Collectionitem from "./Collectionitem";
import Img1 from "../assets/img/Js.png";
import Img2 from "../assets/img/ReactJs.png";
import Img3 from "../assets/img/Python.png";
import Img4 from "../assets/img/LuaJs.png";
import Img5 from "../assets/img/Csharp.png";
import Img6 from "../assets/img/C++.png";
import Img7 from "../assets/img/Css3.png";
import Img8 from "../assets/img/Php.png";

export default function Collections() {
  return (
    <Container className="py-5">
      <h3 className="font-secondary color-primary fs-40">
        <u>Principais Linguagens</u> <i class="bi bi-arrow-right"></i>
      </h3>
      <Row>
        <Collectionitem img={Img1} text="JavaScript" />
        <Collectionitem img={Img2} text="ReactJs" />
        <Collectionitem img={Img3} text="Python" />
        <Collectionitem img={Img4} text="LuaJs" />
        <Collectionitem img={Img5} text="C#" />
        <Collectionitem img={Img6} text="C++" />
        <Collectionitem img={Img7} text="Css3" />
        <Collectionitem img={Img8} text="PHP" />
      </Row>
    </Container>
  );
}
